import * as ActionTypes from "../../actions/grantApplicationForm/types";

const initialState = {
    countries: [],
    counties: [],
    currencies: [],
    organization: null,

    requestResult: null,
    documentsResult: null,
    documentsList: [],
    requestNumber: null,

    loading: false,
    error: null
};
const extractErrorMessage = (payload) => {
    if (!payload) return "Unknown error";

    if (typeof payload.message === "string") {
        return payload.message;
    }
    if (payload.message && typeof payload.message.message === "string") {
        return payload.message.message;
    }
    if (payload.message && payload.message.error) {
        return payload.message.error;
    }

    try {
        return JSON.stringify(payload);
    } catch {
        return "Unexpected error";
    }
};

const handlers = {
    [ActionTypes.FETCH_COUNTRIES]: (state) => ({
        ...state,
        loading: true,
        error: null,
    }),
    [ActionTypes.FETCH_COUNTRIES_SUCCEEDED]: (state, action) => ({
        ...state,
        loading: false,
        countries: action.payload,
    }),
    [ActionTypes.FETCH_COUNTRIES_FAILED]: (state, action) => ({
        ...state,
        loading: false,
        error: action.payload.message,
    }),

    [ActionTypes.FETCH_COUNTIES]: (state) => ({
        ...state,
        loading: true,
        error: null,
    }),
    [ActionTypes.FETCH_COUNTIES_SUCCEEDED]: (state, action) => ({
        ...state,
        loading: false,
        counties: action.payload,
    }),
    [ActionTypes.FETCH_COUNTIES_FAILED]: (state, action) => ({
        ...state,
        loading: false,
        error: action.payload.message,
    }),

    [ActionTypes.FETCH_CURRENCIES]: (state) => ({
        ...state,
        loading: true,
        error: null,
    }),
    [ActionTypes.FETCH_CURRENCIES_SUCCEEDED]: (state, action) => ({
        ...state,
        loading: false,
        currencies: action.payload,
    }),
    [ActionTypes.FETCH_CURRENCIES_FAILED]: (state, action) => ({
        ...state,
        loading: false,
        error: action.payload.message,
    }),

    [ActionTypes.FIND_ORGANIZATION]: (state) => ({
        ...state,
        loading: true,
        error: null,
        organization: null,
    }),
    [ActionTypes.FIND_ORGANIZATION_SUCCEEDED]: (state, action) => ({
        ...state,
        loading: false,
        organization: action.payload,
        error: null,
    }),
    [ActionTypes.FIND_ORGANIZATION_FAILED]: (state, action) => ({
        ...state,
        loading: false,
        organization: null,
        error: action.payload.message,
    }),

    [ActionTypes.CREATE_REQUEST]: (state) => ({
        ...state,
        loading: true,
        error: null,
    }),
    [ActionTypes.CREATE_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loading: false,
        requestResult: action.payload,
    }),
    [ActionTypes.CREATE_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loading: false,
        error: extractErrorMessage(action.payload),
    }),


    [ActionTypes.REQUEST_DOCUMENTS]: (state) => ({
        ...state,
        loading: true,
        error: null,
    }),
    [ActionTypes.REQUEST_DOCUMENTS_SUCCEEDED]: (state, action) => ({
        ...state,
        loading: false,
        documentsResult: action.payload,
    }),
    [ActionTypes.REQUEST_DOCUMENTS_FAILED]: (state, action) => ({
        ...state,
        loading: false,
        error: action.payload.message,
    }),

    [ActionTypes.REQUEST_DOCUMENTS_LIST]: (state) => ({
        ...state,
        loading: true,
        error: null,
    }),
    [ActionTypes.REQUEST_DOCUMENTS_LIST_SUCCEEDED]: (state, action) => ({
        ...state,
        loading: false,
        documentsList: action.payload,
    }),
    [ActionTypes.REQUEST_DOCUMENTS_LIST_FAILED]: (state, action) => ({
        ...state,
        loading: false,
        error: action.payload.message,
    }),

    [ActionTypes.REQUEST_NUMBER]: (state) => ({
        ...state,
        loading: true,
        error: null,
    }),
    [ActionTypes.REQUEST_NUMBER_SUCCEEDED]: (state, action) => ({
        ...state,
        loading: false,
        requestNumber: action.payload,
    }),
    [ActionTypes.REQUEST_NUMBER_FAILED]: (state, action) => ({
        ...state,
        loading: false,
        error: action.payload.message,
    }),
};

export default {
    initialState,
    handlers
};
